import React, { FunctionComponent, useEffect, useRef } from "react";
import { Box } from "@mui/material";

import { CommentDTO, UtilityBillByIdDTO } from "api";
import { useCommentsByUtilityBill } from "hooks";
import { useAuthenticatedUserState } from "recoils";
import {
  FLEX_CENTER_POSITIONING_STYLE,
  Label14SemiBold,
  Loading,
  CommentTextField,
  CommonComment,
} from "components";

export const UtilityBillCommentsView: FunctionComponent<{
  utilityBill: UtilityBillByIdDTO;
}> = ({ utilityBill }) => {
  const {
    data: comments,
    isError,
    isLoading,
  } = useCommentsByUtilityBill(utilityBill.id);
  const user = useAuthenticatedUserState();
  const shouldScrollToComment = useRef<boolean>(true);

  useEffect(() => {
    if (shouldScrollToComment.current && comments) {
      const commentId = window.location.href.split("#")[1];
      const element = document.getElementById(commentId);

      if (element) {
        element.scrollIntoView();
      }

      shouldScrollToComment.current = false;
    }
  }, [comments, shouldScrollToComment]);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          maxHeight: "calc(100dvh - 368px)",
          height: "100%",
          flexGrow: 1,
          backgroundColor: "background.default",
          display: "flex",
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            overflowY: "auto",
            flexDirection: "column",
            padding: 2,
            flexGrow: 1,
            gap: 2,
          }}
        >
          {isLoading && (
            <Loading
              sx={{ height: "100%", ...FLEX_CENTER_POSITIONING_STYLE }}
            />
          )}
          {isError && (
            <Label14SemiBold sx={{ m: 2 }}>
              Failed to fetch comments
            </Label14SemiBold>
          )}
          {!comments?.length && (
            <Label14SemiBold sx={{ m: 2 }}>No comments</Label14SemiBold>
          )}
          {!isError &&
            comments?.map((comment: CommentDTO) => (
              <Box
                key={comment.id}
                id={`${comment.id}`}
                sx={{
                  width: "66%",
                  alignSelf:
                    comment.authorEmail === user.email
                      ? "flex-end"
                      : "flex-start",
                }}
              >
                <CommonComment comment={comment} currentUserId={user.id} />
              </Box>
            ))}
        </Box>
      </Box>
      {!isError && (
        <CommentTextField id={utilityBill.id} siteId={utilityBill.siteId} />
      )}
    </Box>
  );
};
